import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
  data:any = [];
  index:any=[];
  loader:boolean = true;
  orgObj: any;
  orgName;
  search;
  orgId:any = localStorage.getItem('organizationId');
    newOrgObject;
  constructor(public service:ApiService, public auth:AuthService, public handler:HandlerService, private bottomSheet: MatBottomSheet) { }
  ionViewWillEnter(){
    sessionStorage.setItem('orgId',this.orgId)
    this.orgObj=JSON.parse(localStorage.getItem('capabilityOrg'));
    let obj=[];
     this.orgObj.map(res => {
     let x = this.auth.getOrgCapabilities( res.id, 'SP');
     if(x==true){
     obj.push(res)
     }
    })
    this.newOrgObject=obj;
    let org=this.newOrgObject.find(dat=>dat.id==this.orgId);
    if(org)
    this.orgName=org.name;
     else{
       this.orgName=this.newOrgObject[0].name;
       this.orgId=this.newOrgObject[0].id;
     }
    setTimeout(() => {
      this.conf();
      
    }, 1500);
  }
  save(){
    if(this.index.length > 0){
    this.loader = true;
    }
    this.index.map(res=>{
      this.data[res]
      this.service.postConfig(this.data[res].configs).subscribe(res=>{
        this.handler.res('Updated Successfully !!');
        this.loader = false;
        this.auth.getConfig();
   
      }, err => {
        this.loader = false;
        this.handler.err(err)
      })
      })
  }
  checked(data,index){
    this.index.push(index)
    this.index=this.index.filter((x,i,a)=>a.indexOf(x) == i );
  }
  change(data,index){
    this.index.push(index)
    this.index=this.index.filter((x,i,a)=>a.indexOf(x) == i );
  }
 cancel(){
  history.back();
 }
 async conf(){
  this.data= await this.service.getConfig().toPromise();
  this.loader = false;
 }
 openBottomSheetOrg(): void {
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.newOrgObject,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    if(res){
    this.loader=true;
    this.orgName = res.name;
    sessionStorage.setItem('orgId',res.id);
    setTimeout(() => {
      this.conf();
    }, 500);
    
  }
   });
}
ionViewWillLeave(){
  sessionStorage.clear();
  this.search = "";
  }
}